import DocumentEditor from './components/InstagramAdEditor';
import DocumentPreview from './components/InstagramAdPreview';
import { getTxtContent, getPdfContent, getCsvContent } from './InstagramAd.getContent';
import Icon from './InstagramAd.icon';

const MAX_INSTAGRAM_PRIMARYTEXT_CHARS = 125;

const getWordCounts = (document) => {
  return [{
    title: 'Content',
    value: document.content,
    limit: MAX_INSTAGRAM_PRIMARYTEXT_CHARS,
  }];
};

export default {
  DocumentEditor,
  DocumentPreview,
  getTxtContent,
  getPdfContent,
  getCsvContent,
  Icon,
  getWordCounts,
  onMoreLikeThis: async (props, document) => {
    if (!props.canManageDocuments) {
      return null;
    }

    return props.generate({ likeId: document._id });
  },
};
